<template>
    <div class="agent-bubble-chart" :class="{ fullscreen: fullScreen }">
        <div class="title" v-if="fullScreen">
            <ChartDoddleIcon />
            <h2>Temsilci</h2>
        </div>
        <div class="toolbar">
            <div class="left">
                <div class="buttons">
                    <IconButton
                        :classNames="tableMode ? '' : 'selected'"
                        :onClick="() => (tableMode = false)"
                        v-tippy="{ content: $t('report.chartView') }"
                    >
                        <md-icon>insights</md-icon>
                    </IconButton>
                    <IconButton
                        :classNames="tableMode ? 'selected' : ''"
                        :onClick="() => (tableMode = true)"
                        v-tippy="{ content: $t('report.tableView') }"
                    >
                        <md-icon>table_view</md-icon>
                    </IconButton>
                    <IconButton :onClick="exportToExcel" v-tippy="{ content: $t('report.download') }">
                        <md-icon>download</md-icon>
                    </IconButton>
                    <IconButton :onClick="switchToFullScreenMode" v-tippy="{ content: $t('report.fullScreen') }">
                        <md-icon v-if="!fullScreen">fullscreen</md-icon>
                        <md-icon v-else>fullscreen_exit</md-icon>
                    </IconButton>
                </div>
            </div>
        </div>
        <BubbleChart
            title="Temsilci Sayısı"
            :legends="legends"
            :colors="colors"
            :series="getSeries()"
            v-if="!tableMode"
        />
        <TableView :cols="getCols()" :rows="getRows()" v-if="tableMode" />
        <div class="stats">
            <StatCard :title="$t('report.total')" :value="stats.TotalSiteCount" unit="site" />
            <StatCard :title="$t('report.average')" :value="stats.AverageAgentCount" unit="temsilci" />
            <StatCard :title="$t('report.max')" :value="stats.MaxAgentCount" unit="temsilci" />
            <StatCard :title="$t('report.min')" :value="stats.MinAgentCount" unit="temsilci" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import * as echarts from "echarts/lib/echarts";
import _ from "lodash";
import IconButton from "../../Pages/Settings/components/IconButton.vue";
import StatCard from "../../Pages/Chatbot/pages/reports/charts/StatCard.vue";
import TableView from "../../Pages/Chatbot/pages/reports/charts/TableView.vue";
import { expertToExcel } from "../../../utils/utils";
import { dateToHourFromSecondsShortFormat } from "../../../utils/filters";
import { ADMIN_REPORT_API } from "../../../api/statistics";
import log2 from "../../../utils/log2";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import fscreen from "fscreen";

const log = log2("AgentBubbleChart");
export default Vue.extend({
    name: "AgentBubbleChart",
    components: { ChartDoddleIcon, TableView, IconButton, StatCard },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            colors: ["#FFBF00"],
            legends: [this.$t("message.agentCount")],
            stats: {
                TotalSiteCount: 0,
                AverageAgentCount: 0,
                MaxAgentCount: 0,
                MinAgentCount: 0,
            },
            tableMode: false,
            loading: true,
            loadingInstance: null,
            data: [],
            fullScreen: false,
            cancels: [],
        };
    },
    methods: {
        switchToFullScreenMode() {
            if (this.fullScreen) {
                this.closeFullScreenMode();
            } else {
                const elem = document.querySelector(".agent-bubble-chart");
                fscreen.requestFullscreen(elem);
                this.fullScreen = true;
            }
        },
        closeFullScreenMode() {
            fscreen.exitFullscreen();
        },
        fetch() {
            this.loading = true;
            this.loadingInstance.show();
            ADMIN_REPORT_API.siteAgentsBubble(this.filters)
                .then((res) => {
                    log("siteAgentsBubble data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getCols() {
            return [
                {
                    key: "date",
                    field: "date",
                    title: this.$t("chatbotv2.date"),
                },
                {
                    key: "siteCount",
                    field: "siteCount",
                    title: this.$t("report.siteCount"),
                },
            ];
        },
        getRows() {
            const rows = this.data.map((item) => {
                return [item.agentCount, item.siteCount];
            });
            return rows;
        },
        getStats() {
            const agentCounts = this.data.map((x) => x.agentCount);
            const siteCounts = this.data.map((x) => x.siteCount);
            const isEmpty = agentCounts.length === 0;
            const TotalSiteCount = isEmpty ? 0 : _.chain(siteCounts).sum().value();
            const AverageAgentCount = isEmpty ? 0 : parseInt(_.mean(agentCounts).toFixed(1));
            const MaxAgentCount = isEmpty ? 0 : parseInt(_.max(agentCounts).toFixed(1));
            const MinAgentCount = isEmpty ? 0 : parseInt(_.min(agentCounts).toFixed(1));

            return {
                TotalSiteCount,
                AverageAgentCount,
                MaxAgentCount,
                MinAgentCount,
            };
        },
        getSeries() {
            //[x, y, r(yarıçap), "name"]
            const data = this.data.map((item, index) => {
                return [item.agentCount, item.agentCount, item.siteCount, item.siteCount];
            });
            console.log("data..", { data: JSON.stringify(data) });

            return [
                {
                    name: "2015",
                    data: data,
                    type: "scatter",
                    symbolSize: function (data) {
                        return data[2];
                    },
                    emphasis: {
                        focus: "series",
                        label: {
                            show: true,
                            formatter: function (param) {
                                return param.data[3];
                            },
                            position: "top",
                        },
                    },
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: "rgba(25, 100, 150, 0.5)",
                        shadowOffsetY: 5,
                        color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                            {
                                offset: 0,
                                color: "rgb(129, 227, 238)",
                            },
                            {
                                offset: 1,
                                color: "rgb(25, 183, 207)",
                            },
                        ]),
                    },
                },
            ];
        },
        exportToExcel() {
            const data = this.data.map((item) => {
                return [item.agentCount, item.siteCount];
            });
            const stats = this.getStats();
            const excelData = [
                ...data,
                {
                    date: "Toplam site",
                    siteCount: stats.TotalSiteCount,
                },
                {
                    date: "Ortalama temsilci",
                    siteCount: stats.AverageAgentCount,
                },
                {
                    date: "Maksimum temsilci",
                    siteCount: stats.MaxAgentCount,
                },
                {
                    date: "Minimum temsilci",
                    siteCount: stats.MinAgentCount,
                },
            ];
            expertToExcel(excelData, `site_count_timeseries.xlsx`, "Sheet 1");
        },
    },
    created() {
        const fullscreenCallback = () => {
            console.log("fullscreenCallback", fscreen.fullscreenElement);
            this.fullScreen = fscreen.fullscreenElement !== null;
            this.$forceUpdate();
        };
        fscreen.addEventListener("fullscreenchange", fullscreenCallback);
        this.cancels.push(() => {
            fscreen.removeEventListener("fullscreenchange", fullscreenCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".agent-bubble-chart"),
            name: "wave",
        });
        this.stats = this.getStats();
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        data: {
            handler: function (val, oldVal) {
                this.stats = this.getStats();
            },
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
    },
});
</script>
<style lang="scss">
.agent-bubble-chart {
    .title {
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        margin: 0;

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 40px;
            margin: 0 !important;
        }
    }

    &.fullscreen {
        background-color: #fff;
        padding: 20px;
        overflow-y: scroll;

        .stacked-area-chart {
            height: calc(100vh - 200px);
        }
    }
}
</style>
<style scoped lang="scss">
.agent-bubble-chart {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;

            .buttons {
                display: flex;
                border: 1px solid var(--color-border-default);

                .icon-button {
                    padding: 5px;
                    width: 40px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid var(--color-border-default);
                    border-radius: unset !important;

                    &.selected {
                        background-color: var(--color-bg-info-low-hover);

                        i {
                            color: rgb(55, 162, 255);
                        }
                    }

                    &:hover {
                        background-color: var(--color-bg-neutral-pressed);
                    }
                }

                .icon-button:last-child {
                    border-right: none;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
        }
    }

    .stats {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
